<template>
  <VLayout style="height: calc(100vh - 100px)" row align-center>
    <VFlex xs12 sm10 md8 lg6 offset-sm1 offset-md2 offset-lg3>
      <form @submit.prevent="validateBeforeSubmit">
        <VCard ref="form" class="pa-5">
          <VCardTitle primary-title>
            <div style="width: 100%">
              <h3 class="headline text-xs-center mb-0">Prijava</h3>
            </div>
          </VCardTitle>
          <VCardText>
            <VTextField
              v-model="username"
              v-validate="'required'"
              label="Uporabniško ime"
              :error-messages="errors.collect('username')"
              data-vv-name="username"
            />
            <VTextField
              v-model="password"
              v-validate="'required'"
              label="Geslo"
              :error-messages="errors.collect('password')"
              :type="'password'"
              data-vv-name="password"
            />
          </VCardText>
          <div class="mt-3">
            <VProgressLinear
              v-if="isLoggingIn"
              value="15"
              height="2"
              color="primary"
              :indeterminate="true"
            />
            <VDivider v-else />
          </div>
          <VCardActions>
            <VSpacer />
            <VFlex>
              <VBtn color="primary" flat type="submit"> Prijava </VBtn>
              <VBtn color="primary" flat @click="loginWithAzure"> Prijava z azure </VBtn>
              <VBtn flat @click="reset"> Počisti </VBtn>
            </VFlex>
          </VCardActions>
        </VCard>
      </form>
    </VFlex>
  </VLayout>
</template>
<script>
/* no-useless-escape */

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      username: '',
      password: '',
      snackBar: false,
      isLoggingIn: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
  },
  methods: {
    async validateBeforeSubmit() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          const authenticationData = {
            username: this.username,
            password: this.password,
          };
          this.isLoggingIn = true;
          await this.$store.dispatch('login', authenticationData);
          this.$router.push('dashboard');
        }
      } catch (err) {
        if (err.response.status === 401) {
          this.errors.add({
            field: 'password',
            msg: 'Napačno geslo ali uporabniško ime',
          });
          this.errors.add({
            field: 'username',
            msg: 'Napačno geslo ali uporabniško ime',
          });
        }
      } finally {
        this.isLoggingIn = false;
      }
    },
    async loginWithAzure() {
      await this.$store.dispatch('getAzureAccessToken');
      this.$router.push('dashboard');
    },
    async reset() {
      this.username = '';
      this.password = '';
      await this.$validator.reset();
    },
  },
};
</script>
<style scoped></style>
